var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.508 8.34H7.949l1.172-1.743a1.533 1.533 0 0 0-1.268-2.393H7.85a1.67 1.67 0 0 0-1.304.627L2.939 9.34a.8.8 0 0 0 0 1l3.607 4.508a1.67 1.67 0 0 0 1.304.627h.003a1.533 1.533 0 0 0 1.268-2.393L7.95 11.339h11.559a6.728 6.728 0 1 1 0 13.456h-3.272a1.5 1.5 0 0 0 0 3h3.272a9.728 9.728 0 1 0 0-19.456z",
    "data-name": "Arrow Outline",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnWhite);
export default __webpack_public_path__ + "static/media/return-white.794ef2563ea393d92015bff65b8d37d7.svg";
export { ForwardRef as ReactComponent };